import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from '../../../shared/services/courier.service';
import { GetOdometerValueRequest, GetOdometerValueResponse, PostOdometrStartValueRequest } from '../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { ServiceService } from '../../../shared/services/service.service';
import { PostCarFaultRequest, SetCarFaultInServiceRequest } from '../../../shared/models/service.models';

@Component({
  templateUrl: 'service-voucher-start-odometer.component.html',
  styleUrls: ['./service-voucher-start-odometer.component.scss']
})
export class ServiceVoucherStartOdometerComponent implements OnInit {

  odometerResponse: GetOdometerValueResponse | null = null;
  startOdometerValue: number = 0;
  startHours: number = 0;
  startMinutes: number = 0;
  chosenDate: Date = new Date();
  isButtonDisabled: boolean = false;
  hours: { value: number }[] = Array.from({ length: 24 }, (_, i) => ({ value: i }));
  minutes: { value: number }[] = Array.from({ length: 12 }, (_, i) => ({ value: i * 5 }));
  loading: boolean = false;
  isMobile: boolean = false;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private serviceService: ServiceService,
    private router: Router
  ) {}

  ngOnInit() {
    this.checkIfMobile();
    this.loadOdometer();
  }

  @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      this.checkIfMobile();
    }
  
    private checkIfMobile() {
      this.isMobile = window.innerWidth <= 768;
    }

  loadOdometer() {
    this.loading = true;
    const carId = this.activeUserLocalDataService.newServiceVoucherCarId;
    if (!carId) {
      console.error('Car ID is null, redirecting to /service-pick-car');
      this.router.navigate(['/service-pick-car']);
      return;
    }
    const request: GetOdometerValueRequest = { carId };
    this.courierService.getOdometrValue(request).subscribe((response: GetOdometerValueResponse) => {
      this.odometerResponse = response;
      this.startOdometerValue = this.odometerResponse?.odometerValue.odometerEndVal ?? 0;
      this.startHours = new Date().getHours();
      this.startMinutes = Math.round(new Date().getMinutes() / 5.0) * 5;
      this.loading = false;
    });
  }

  dayBack() {
    const changedDate = new Date(this.chosenDate);
    changedDate.setDate(changedDate.getDate() - 1);
    this.chosenDate = changedDate;
  }

  dayForward() {
    const changedDate = new Date(this.chosenDate);
    changedDate.setDate(changedDate.getDate() + 1);
    this.chosenDate = changedDate;
  }

  startVoucher() {
    this.isButtonDisabled = true;
    const date = new Date(this.chosenDate);
    date.setHours(this.startHours);
    date.setMinutes(this.startMinutes);
    const carId = this.activeUserLocalDataService.newServiceVoucherCarId;
    const clientId = this.activeUserLocalDataService.newServiceVoucherServiceId;
    if (carId && clientId) {
      const request: PostOdometrStartValueRequest = {
        odometerStartVal: this.startOdometerValue,
        carId,
        clientsId: clientId,
        routesId: undefined,
        regionId: undefined,
        workStartTime: date,
        createdFromWeb: true,
        isService: true
      };
      this.courierService.postStart(request).subscribe({
        next: (response) => {
          this.activeUserLocalDataService.newServiceVoucherComments?.forEach(comment => {
            const faultRequest: PostCarFaultRequest = {
              carId,
              voucherId: response.id,
              faultNotes: comment
            };
            this.serviceService.postCarFault(faultRequest).subscribe();
          });
          this.activeUserLocalDataService.newServiceFixExistingCarFaultsList.forEach(faultId => {
            const faultInServiceRequest: SetCarFaultInServiceRequest = {
              carId,
              voucherId: response.id,
              carFaultId: faultId
            };
            this.serviceService.setCarFaultInService(faultInServiceRequest).subscribe();
          });
          this.activeUserLocalDataService.setActiveServiceVoucherId(response.id ?? 0);
          this.router.navigate(['/service-voucher']);
        },
        error: (error) => {
          console.error('Error starting voucher:', error);
          if (error.status === 400 && error.error?.ValidationErrors) {
            error.error.ValidationErrors.forEach((validationError: any) => {
              console.error('Validation error:', validationError);
            });
          }
          this.isButtonDisabled = false;
        }
      });
    }
  }

  goBack() {
    this.router.navigate(['/service-voucher-start-pick-service']);
  }
}